export default __webpack_public_path__ + "static/media/logo4.e1cd88ef.png";